import type { DeletedPaymentDetails } from '@approvalmax/types';
import { Table, Text } from '@approvalmax/ui/src/components';
import { ColumnDefinition } from '@approvalmax/ui/src/components/Table/Table.types';

import { messages } from './DeletedPaymentDetailsPopupContent.messages';

export const getTableColumns = (): ColumnDefinition<DeletedPaymentDetails>[] => [
    {
        id: 'name',
        name: messages.tableHeaderContact,
        cellComponent: (props) => (
            <Table.Cell {...props}>
                <Text font='label' ellipsis={1} color='red100' fontWeight='medium' title={props.item.name}>
                    {props.item.name}
                </Text>
            </Table.Cell>
        ),
    },
];
